import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';

import { Partner } from '@/configs/partner';
import { useProducts } from '@/queries/Products';
import { Product } from '@/queries/types/graphql';

export interface PartnerProductsData {
  isLoading: boolean;
  isError: boolean;
  data: Product[];
  refetch: (
    options?: RefetchOptions,
  ) => Promise<QueryObserverResult<Product[], Error>>;
}

const usePartnerProducts = (partner: Partner): PartnerProductsData => {
  const {
    data: productData,
    isLoading: productDataLoading,
    isError: productDataError,
    refetch: refetchProducts,
  } = useProducts({ productType: 'Ring', contentFilter: { channel: 'b2b' } });

  // For business.ouraring.com, return all product data
  if (partner === Partner.business) {
    return {
      isLoading: productDataLoading,
      isError: productDataError,
      data: productData ?? [],
      refetch: refetchProducts,
    };
  }

  return {
    isLoading: productDataLoading,
    isError: productDataError,
    data: productData ?? [],
    refetch: refetchProducts,
  };
};

export default usePartnerProducts;
